<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-notepad heroicon heroicon-sm"
  >
    <rect
      class="heroicon-notepad-binding heroicon-component-accent heroicon-component-fill"
      width="46"
      height="8"
      x="7"
      y="1"
      fill="#7ACFC0"
    ></rect>
    <rect
      class="heroicon-notepad-pages heroicon-component-fill"
      width="46"
      height="50"
      x="7"
      y="9"
      fill="#FFFFFF"
    ></rect>
    <polygon
      class="heroicon-shadows"
      fill="#000000"
      points="42 51 6 51 6 60 54 60 54 41 42 41"
      opacity=".2"
    ></polygon>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M6 8V0h48v60H6V8zm43.27 43H52v-2.5c-.75 1-1.67 1.84-2.73 2.5zM42 51V41h7c1.13 0 2.16-.37 3-1V10H8v41h34zM8 57v1h44v-1H37v-1h15v-1H33v-1h19v-1H8v1h12v1H8v1h18v1H8zM8 7v1h44V7H8zm0-1h44V2H8v4zm44 36.33c-.9.43-1.93.67-3 .67h-5v8a8 8 0 0 0 8-8v-.67zM14 16h28v1H14v-1zm28 2v1H14v-1h28zm-28 2h32v1H14v-1zm30 2v1H14v-1h30zm-30 5h30v1H14v-1zm32 2v1H14v-1h32zm-32 2h31v1H14v-1zm25 2v1H14v-1h25zm-25 3h32v1H14v-1zm30 2v1H14v-1h30zm-30 2h26v1H14v-1zm0 2h12v1H14v-1zm0-18h20v1H14v-1zm2-20h4v1h-4V4zm28 0v1h-4V4h4z"
    ></path>
  </svg>
</template>
